import { createFileRoute } from '@tanstack/react-router';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Loading } from '@/components/Loading';
import { activeConfig } from '@/config';
import ProfilePage from '@/components/pages/profile';

const ProtectedSettings = withAuthenticationRequired(ProfilePage, {
  onRedirecting: () => <Loading />,
});

export const Route = createFileRoute('/profile/')({
  head: () => ({
    meta: [{ title: `My Profile | ${activeConfig.branding.appName}` }],
  }),
  component: ProtectedSettings,
});
